var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 23.412,
    height: 20.561,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ec812d;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 10.00)",
    className: "cls-1",
    d: "m20.36,33.27c5.85-9.04,12.77-17.38,20.39-25.18,2.13-2.13,4.08,0,2.48,1.95-8.16,8.87-13.3,17.55-18.8,28.37-1.24,2.13-5.14,4.08-6.74,1.6-3.19-5.5-4.96-11.88-11.53-12.59,9.04-8.69,10.28-.53,14.19,5.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckOrange);
export default __webpack_public_path__ + "static/media/icon-check-orange.5f4c9dd40c2d17510e90ab91dd4b466c.svg";
export { ForwardRef as ReactComponent };